import React from 'react';

/**
 * Dernier recours contre l'écran blanc : sans lui, toute exception de rendu démonte
 * l'arbre React entier. Ne capte ni les gestionnaires d'événements ni l'asynchrone —
 * les états `error` des composants restent la voie normale.
 * Classe imposée : `getDerivedStateFromError` n'a pas d'équivalent hook.
 */
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error(`[ErrorBoundary] ${this.props.title || 'section'} :`, error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex items-center justify-center p-6 h-full" role="alert">
        <div className="max-w-md w-full p-6 rounded-lg bg-white dark:bg-gray-800 border border-red-300 dark:border-red-800 shadow">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
            {this.props.title || 'Cette section n\'a pas pu s\'afficher'}
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
            Le reste de la page reste utilisable. Recharger suffit le plus souvent ; si l'erreur
            revient, signalez-la avec l'adresse de la page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
